import React from "react";
// Store Utils
import { useDispatch } from "react-redux";
import { organizationsStatusAction } from "store/filters/reducer.actions";
import { useSelector } from "react-redux";
import { RootState } from "store";
import { sentenceCase } from "change-case";
import { filtersInitialState } from "store/filters/initialState";

interface TabsProps {}

export const Tabs: React.FC<TabsProps> = ({}) => {
  const { organizationsFilter } = useSelector<RootState,filtersInitialState>((state) => state.Filters)
  const dispatch = useDispatch();
  const TabsData = ["active", "archived"];

  //handlers
  const handleLink = (linkName: string) => {
    dispatch(organizationsStatusAction(linkName));
  };

  return (
    <>
      {TabsData.map((item: any, index: number) => {
        return (
          <div
            key={index}
            className={`flex cursor-pointer justify-center items-center flex-grow-0 flex-shrink-0 px-4 py-3 ${
              organizationsFilter.status === item
                ? "border-b-2 border-primaryMid "
                : "border-lineMid border-b-2  hover:border-lineDarkExtra"
            }`}
            onClick={() => handleLink(item)}
          >
            <div className="flex justify-center items-center flex-grow-0 flex-shrink-0 relative px-1.5 pt-1.5 pb-2 ">
              <p className="flex-grow-0 flex-shrink-0 text-sm font-semibold text-center uppercase text-secondary dark:text-caption ">
                {/* {sentenceCase(item)} */}
                {item}
              </p>
            </div>
          </div>
        );
      })}
    </>
  );
};
